import { COLLAPSE_SIDEBAR } from '@store/actions/types';

const initialState = {
	isCollapsed: false,
	activeTab: window.location.pathname,
	refresh: false
};

export default (state = initialState, action) => {
	switch (action.type) {
		case COLLAPSE_SIDEBAR:
			return { isCollapsed: action.payload.isCollapsed };
		case 'SET_ACTIVE_TAB':
			return { activeTab: action.payload, refresh: !state.refresh };
		default:
			return state;
	}
};
